export default "<p>input-std-sku works!</p>\n"